enum MembershipSlug {
	AiChatAccess = 'ai_chat_access'
}

export default MembershipSlug
